import { CopilotLogo } from "../ui/CopilotLogo";

interface LoadingScreenProps {
  message?: string;
}

/** Full-viewport loading indicator used as the router Suspense fallback. */
export function LoadingScreen({
  message = "Loading…",
}: LoadingScreenProps): JSX.Element {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="spinner" aria-hidden>
        <CopilotLogo size={42} active />
      </div>
      <div className="loading-text">{message}</div>
    </div>
  );
}
